// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    pdfTemplates: "PDF Templates",
    pdfTemplateFor: "PDF Template for",
    documentation: "Documentation",
    settingsTab: "Settings",
    styleTab: "Style",
    sectionsTab: "Sections",
    attachmentsTab: "Attachments",
    backToSections: "Back to Sections",
    globalSectionDescription: "Global section - renders once per PDF",
    perGoalSectionDescription: "Per-goal section - repeats for each goal",
    failedToLoadSection: "Failed to load section content. Please try again.",
    loading: "Loading...",
    templateNotFound: "Template not found",
  },
  nb_NO: {
    settings: "Innstillinger",
    pdfTemplates: "PDF-maler",
    pdfTemplateFor: "PDF-mal for",
    documentation: "Dokumentasjon",
    settingsTab: "Innstillinger",
    styleTab: "Stil",
    sectionsTab: "Seksjoner",
    attachmentsTab: "Vedlegg",
    backToSections: "Tilbake til seksjoner",
    globalSectionDescription: "Global seksjon - vises én gang per PDF",
    perGoalSectionDescription: "Per-mål seksjon - gjentas for hvert mål",
    failedToLoadSection: "Kunne ikke laste seksjonsinnhold. Vennligst prøv igjen.",
    loading: "Laster...",
    templateNotFound: "Mal ikke funnet",
  },
} as const;
